import './App.css';
import React, {useEffect} from 'react';
import {RouterComponent} from "./RouterComponent";
import {Navbar} from "./Components/Navbar";
import {Alert, Layout, Spin} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {Player} from "./Components/Player";
import {getCurrentUserThunk} from "./Feature/UsersSlice";
import {getSpacesThunk} from "./Feature/SpacesSlice";
import {getHealthThunk} from "./Feature/HealthSlice";
import {ErrorScreen} from "./Views/ErrorScreen";

const MINUTE_MS = 60000;

function App() {

    const dispatch = useDispatch();

    const user = useSelector((state) => {
        return state.firebase.auth
    });

    const isHealthy = useSelector((state) => {
        return state.health.health.status === 'UP'
    });

    const currentRecording = useSelector((state) => {
        return state.recordings.currentRecording
    });
    const currentUser = useSelector((state) => state.users);

    useEffect(() => {
        dispatch(getHealthThunk())
        const interval = setInterval(() => {
            dispatch(getHealthThunk())
        }, MINUTE_MS);
        return () => clearInterval(interval);
    }, [dispatch])


    useEffect(() => {
        if (!user.uid || !isHealthy) {
            return;
        }
        dispatch(getCurrentUserThunk()).then((result) => {
            if (getCurrentUserThunk.fulfilled.match(result)) {
                dispatch(getSpacesThunk());
            }
        });
    }, [dispatch, user.uid, isHealthy]);

    return (<>
            {user.isEmpty ? <RouterComponent/> :
                (<Layout style={{minHeight: "100vh"}}>
                    <Navbar/>
                    <Layout>
                        <Layout.Content>
                            {
                                !isHealthy ? <ErrorScreen/> :
                                    currentUser.status === 'failed' ?
                                        <Alert message="Unable to load your account" description={currentUser.error} type="error" showIcon/> :
                                    currentUser.status === 'succeeded' && currentUser.current?.login_id === user.uid ?
                                        <RouterComponent/> : <Spin/>
                            }
                        </Layout.Content>
                    </Layout>
                    {currentRecording && <div className="floating-player"><Player/></div>}
                </Layout>)}
        </>

    );
}

export default App;
